<template>
  <div>
    <div class="elder_manage_title">
      <p class="title">
        <slot name="title" style="margin-top: 0;"></slot>
      </p>
    </div>
    <div class="search_wrapper">
      <div class="search_head">
        <span>查询条件</span>
        <!-- <el-button
          style="float: right; padding: 3px 0; color: #000"
          type="text"
          @click="Reset"
        >
          <i class="el-icon-refresh"></i>
          刷新页面
        </el-button> -->
        <i class="searchDomw" @click="isSearchContent = !isSearchContent" :class="isSearchContent==true?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
      </div>
      <div class="search_content" v-show="isSearchContent">
        <div class="search_inline">
          <slot name="search"></slot>
        </div>
        <!-- <div class="arrowDown">
          <i
            class="el-icon-arrow-down"
            style="color: #000"
            @click="isSearchContent = !isSearchContent"
          ></i>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'globalTag',
  data () {
    return {
      isSearchContent: true
    }
  },
  inject: ["reload"], //注入
  methods:{
    // 页面刷新
    Reset() {
      this.reload();
    },
  }
};
</script>

<style lang="less" scoped>
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;
  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }
  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    margin-top: 0!important;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}
/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(151, 151, 151, .16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw{cursor: pointer;}

</style>